<template>
  <div class="draw-invoice">
    <van-cell
      class="invoice-cell cell-value-min-width"
      v-if="drawInvoice"
      title="开票方式"
      value="电子发票"
      :border="false"
    >
      <!-- <template slot="default">
        <van-radio-group class="radio-icon" style="margin-top: 2px" v-model="invoiceWay" direction="horizontal">
          <van-radio class="custom-margin-right-23" :name="2">电子发票</van-radio>
          <van-radio class="right-radio" :name="1">纸质发票</van-radio>
        </van-radio-group>
      </template> -->
    </van-cell>

    <van-cell
      :border="false"
      class="invoice-cell cell-title select-cell"
      v-if="drawInvoice"
      title="发票抬头"
      @click="chooseInvoiceType = true"
      is-link
      :value="invoiceTypeCn || '请选择'"
    />

    <!-- <van-cell
      :border="false"
      class="invoice-cell cell-title lang-label select-cell"
      v-if="invoiceTypeCn === invoiceTypeMap.COMPANY && drawInvoice"
      title="发票类型（必填）"
      @click="chooseInvoiceKind = true"
      is-link
      :value="invoiceKindCn || '请选择'"
    /> -->

    <van-field
      class="invoice-cell cell-title lang-label"
      v-if="invoiceTypeCn === invoiceTypeMap.COMPANY && drawInvoice"
      :label="`${invoiceTypeCn}抬头（必填）`"
      placeholder="请输入公司抬头"
      :formatter="formatterTitle"
      placeholder-right
      input-align="right"
      v-model="invoiceTitle"
      clearable
      maxlength="50"
      rows="1"
      type="textarea"
      :border="false"
      autosize
    />
    <div v-if="invoiceTypeCn === invoiceTypeMap.COMPANY && drawInvoice && isTitleError" class="error-tip">
      请输入公司抬头
    </div>

    <van-field
      class="invoice-cell cell-title lang-label"
      v-if="invoiceTypeCn === invoiceTypeMap.COMPANY && drawInvoice"
      label="纳税人识别号（必填）"
      placeholder="请输入纳税人识别号"
      placeholder-right
      input-align="right"
      v-model="invoiceTaxNum"
      :formatter="formatterTaxNum"
      clearable
      maxlength="20"
      :border="false"
    />
    <div v-if="invoiceTypeCn === invoiceTypeMap.COMPANY && drawInvoice && isTaxNumError" class="error-tip">
      请输入纳税人识别号
    </div>

    <van-field
      class="invoice-cell cell-title"
      v-if="invoiceTypeCn === invoiceTypeMap.PERSONAL && drawInvoice"
      label="个人名称"
      placeholder="请输入姓名"
      placeholder-right
      input-align="right"
      v-model="invoiceTitle"
      clearable
      maxlength="20"
      :border="false"
    />
    <div v-if="invoiceTypeCn === invoiceTypeMap.PERSONAL && drawInvoice && isInvoiceTitleError" class="error-tip">
      请输入个人名称
    </div>

    <van-field
      class="invoice-cell cell-title lang-label"
      v-if="invoiceTypeCn && drawInvoice"
      :label="`邮箱或手机号（必填）`"
      placeholder="请输入邮箱或手机"
      placeholder-right
      input-align="right"
      v-model="invoiceReceive"
      clearable
      maxlength="50"
      rows="1"
      type="textarea"
      autosize
      :border="false"
    />
    <div v-if="invoiceTypeCn && drawInvoice && isPhoneError" class="error-tip">请输入邮箱或手机号</div>

    <!-- <div class="line van-hairline--bottom"></div> -->

    <van-popup :value="chooseInvoiceType" position="bottom" :close-on-click-overlay="false" get-container="body">
      <ul class="draw-invoice__type">
        <li v-for="item in invoiceTypeMap" :key="item" @click="invoiceTypeChange(item)">
          {{ item }}
          <icon-font v-if="invoiceTypeCn === item" class="r duihao" icon-name="duihao"></icon-font>
        </li>
        <li @click="chooseInvoiceType = false"><div>取消</div></li>
      </ul>
    </van-popup>

    <van-popup :value="chooseInvoiceKind" position="bottom" :close-on-click-overlay="false" get-container="body">
      <ul class="draw-invoice__type">
        <li v-for="item in invoiceKindMap" :key="item" @click="invoiceKindChange(item)">
          {{ item }}
          <icon-font v-if="invoiceKindCn === item" class="r duihao" icon-name="duihao"></icon-font>
        </li>
        <li @click="chooseInvoiceKind = false"><div>取消</div></li>
      </ul>
    </van-popup>
  </div>
</template>

<script>
const invoiceTypeMap = {
  PERSONAL: '个人',
  COMPANY: '公司'
};

const invoiceKindMap = {
  SPECIAL: '专用发票',
  NORMAL: '普通发票'
};

export default {
  props: {
    drawInvoice: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      invoiceTypeMap: invoiceTypeMap,

      invoiceKindMap: invoiceKindMap,

      invoiceTypeCn: invoiceTypeMap.PERSONAL,

      invoiceKindCn: invoiceKindMap.NORMAL,

      invoiceTitle: '',

      invoiceTaxNum: '',

      invoiceReceive: '',

      invoiceWay: 2,

      chooseInvoiceType: false,

      chooseInvoiceKind: false,

      isInvoiceTitleError: false,

      isTitleError: false,

      isTaxNumError: false,

      isPhoneError: false
    };
  },
  computed: {
    invoiceType() {
      return this.invoiceTypeCn === '个人' ? 1 : 2;
    },

    invoiceKind() {
      // 1:普票 2:专票
      return this.invoiceKindCn === invoiceKindMap.NORMAL ? 1 : 2;
    },

    invoiceInput() {
      // 1个人  2公司
      if (this.invoiceType === 1) {
        // 初始化公司发票信息
        this.invoiceKindCn = invoiceKindMap.NORMAL;
        this.invoiceTaxNum = '';

        // 个人发票抬头默认 个人
        // this.invoiceTitle = this.invoiceTitle;
      }

      // 个人 公司都包含的字段
      const data = {
        invoiceType: this.invoiceType,
        invoiceTitle: this.invoiceTitle,
        invoiceReceive: this.invoiceReceive
      };

      data.invoiceWay = this.invoiceWay;

      if (this.invoiceType === 2) {
        // data.invoiceKind = this.invoiceKind;
        data.invoiceTaxNum = this.invoiceTaxNum.toUpperCase();
      }

      return data;
    }
  },
  watch: {
    drawInvoice: {
      deep: true,
      handler: function (val) {
        if (!val) {
          this.clearErrorStatusOnChange();
        }
      }
    },
    invoiceInput: {
      deep: 'true',
      handler: function (val) {
        this.$emit('inputInvoice', val);
      }
    }
  },
  methods: {
    invoiceTypeChange(value) {
      this.invoiceTypeCn = value;

      this.invoiceTitle = value === invoiceTypeMap.PERSONAL ? '' : '';

      this.chooseInvoiceType = false;

      this.clearErrorStatusOnChange();
    },
    invoiceKindChange(value) {
      this.invoiceKindCn = value;

      this.chooseInvoiceKind = false;
    },

    validate() {
      this.handleTitleBlur();
      this.handleTaxNumBlur();
      this.handleInvoiceTitleError();
      this.handlePhoneBlur();
      if (!this.invoiceTypeCn) {
        this.$toast('请选择发票抬头');
        return false;
      }
      if (this.invoiceType === 2) {
        if (!this.invoiceTitle) {
          this.$toast('请输入公司抬头');
          return false;
        }
        if (!this.invoiceTaxNum) {
          this.$toast('请输入纳税人识别号');
          return false;
        }
      }
      if (this.invoiceType === 1) {
        if (!this.invoiceTitle) {
          this.$toast('请输入个人名称');
          return false;
        }
      }
      if (!this.invoiceReceive) {
        this.$toast('请输入邮箱或手机号');
        return false;
      }

      return true;
    },

    formatterTitle(value) {
      return value.replace(/[^\u4e00-\u9fa5]/g, '');
    },

    formatterTaxNum(value) {
      return value.replace(/[^\w]/g, '');
    },

    handleTitleBlur() {
      this.isTitleError = !this.invoiceTitle;
    },

    handleTaxNumBlur() {
      this.isTaxNumError = !this.invoiceTaxNum;
    },

    handleInvoiceTitleError() {
      this.isInvoiceTitleError = !this.invoiceTitle;
    },

    handlePhoneBlur() {
      this.isPhoneError = !this.invoiceReceive;
    },

    clearErrorStatusOnChange() {
      this.isTitleError = false;
      this.isTaxNumError = false;
      this.isPhoneError = false;
      this.isInvoiceTitleError = false;
    }
  }
};
</script>

<style lang="less" scoped>
.draw-invoice {
  .invoice-cell {
    padding: 8px 0;
    /deep/ .van-cell__title {
      color: #262626;
      font-size: 14px;
      line-height: 20px;
    }
    /deep/ .van-cell__value {
      font-size: 14px;
      input::placeholder {
        font-size: 14px;
      }
      .van-radio-group {
        justify-content: flex-end;
      }
    }
    /deep/ .van-icon {
      font-size: 14px;
    }
    .radio-icon {
      /deep/ .van-icon {
        line-height: 1.5;
      }
    }
  }
  /deep/.van-popup--bottom {
    height: auto;
  }

  /deep/.van-field__control {
    text-align: right;
  }
  .cell-title /deep/ .van-cell__flexrow {
    .van-cell__title {
      color: #262626;
    }
  }
  .cell-title /deep/.van-cell::after {
    border: 0 !important;
  }
  .select-cell /deep/ .van-cell__flexrow {
    .van-cell__value,
    .van-icon-arrow {
      color: #262626;
    }
    .van-icon-cap-arrow {
      color: #bfbfbf;
      font-size: 12px;
    }
  }
  // .title /deep/ .van-field__control {
  //   text-align: left;
  // }
  .cell-value-min-width /deep/ .van-cell__value {
    min-width: 214px;
    .custom-margin-right-23 {
      margin-right: 23px;
    }
    .right-radio {
      margin-right: 0;
    }
    .van-radio__label {
      color: #262626;
    }
  }

  .error-tip {
    padding: 4px 16px;
    background: #ffeeeb;
    font: 400 12px/17px PingFangSC-Regular, PingFang SC;
    color: #ff4e47;
  }

  .lang-label {
    /deep/ .van-cell__flexrow .van-field__label {
      max-width: 160px;
    }
  }

  &__type {
    li {
      height: 48px;
      // padding: 15px 16px;
      padding: 0 16px;
      line-height: 48px;
    }

    li:last-child {
      background: #f7f7f7;
    }

    .duihao {
      width: 20px;
      height: 2em;
      margin-top: 10px;
      color: @green;
    }
  }
}
</style>
